/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
  ViewContainerRef,
} from '@angular/core';

@Injectable()
export class DisplayNotificationUiPanelService {

  componentRef: ComponentRef<unknown> | undefined = undefined;

  rootViewContainer: ViewContainerRef | undefined = undefined;

  firstClick = true;

  constructor(private factoryResolver: ComponentFactoryResolver,
              private appRef: ApplicationRef,
              private injector: Injector) {
  }

  reset(): void {
    this.appRef.detachView(this.componentRef?.hostView);
    this.notificationPanelClicked();
    this.componentRef?.destroy();
  }

  insertSadComponent(component: any): void {
    this.insertComponent(component);
  }

  private insertComponent(componentType: any): void {
    this.componentRef = this.factoryResolver.resolveComponentFactory(componentType).create(this.injector);
    this.appRef.attachView(this.componentRef?.hostView);

    const domElem = (this.componentRef?.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    document.body.appendChild(domElem);
    this.notificationPanelReset();
  }

  notificationPanelClicked() {
    this.firstClick = true;
  }

  notificationPanelReset() {
    this.firstClick = false;
  }

  getNotificationPanelClickState() {
    return this.firstClick;
  }
}
